import React, { useEffect } from "react";
import CountUp from "react-countup";
import { useInView } from "../Hooks/useInView";
import styles from "./NotFound.module.css";
import CustomButton from "../components/CustomButton";

const NotFound: React.FC = () => {
  const [ref, inView] = useInView<HTMLDivElement>(0.5);

  useEffect(() => {
    document.documentElement.classList.add("route-notfound");
    return () => document.documentElement.classList.remove("route-notfound");
  }, []);

  return (
    <section className={styles.notFound} ref={ref}>
      <div className={styles.code}>{inView && <CountUp end={404} duration={2.4} />}</div>
      <p className={styles.message}>Diese Seite existiert nicht</p>
      <CustomButton text="Zur Startseite" to="/" variant="filled" size="large" />
    </section>
  );
};

export default NotFound;
